import { useNavigation } from "@react-navigation/native";
import Constants from "expo-constants";
import React, { useEffect, useState } from "react";
import { Linking, Text, Image } from "react-native";
import Animated, { Extrapolation, interpolate, useAnimatedStyle } from "react-native-reanimated";
import { DrawerComponentContext } from "../provider";
import useStyles from "../styles.css";
import images from "@assets/images";
import { tabletSize } from "@src/utils/screensize-helper";

const CopyRightContent = () => {
  const styles = useStyles();
  const navigation = useNavigation<any>();
  const { animated } = React.useContext(DrawerComponentContext);
  const [ currentYear , setCurrentYear ] = useState("");
  const LogoTech = images.LogoTechUnawa;
  const isTabletSize = tabletSize();

  useEffect (() => {
    const year = new Date().getFullYear();
    setCurrentYear(
      year + ""
    );
  }, []);

  const animateStyle = useAnimatedStyle(() => {
    const opacity = interpolate(
      animated.value,
      [360, 110],
      [1, 0],
      Extrapolation.CLAMP,
    );

    return {
      opacity,
    };
  }, []);

  return (
    <Animated.View style={[styles.drawer_content_footer, { justifyContent: 'flex-end', }, animateStyle]}>
       {!isTabletSize ? 
        <>
        <Image tintColor={'white'} style={{ marginBottom: 3, width:100 , height: 25, left: "12%"}} source={images.LogoUnawa} resizeMode="contain"/>
        <Text style={styles.copyRightStyle}>
          <Text style={styles.copyRightBtnStyle} onPress={() => navigation.navigate("terms-condition")}>Terms & Conditions</Text> |
          <Text style={styles.copyRightBtnStyle} onPress={() => navigation.navigate("privacy-policy")}> Privacy Policy</Text>
          {"\n"}
          © { currentYear + " " }
          <Text style={styles.copyRightBtnStyle} onPress={() => Linking.openURL("https://www.unawa.asia")}>
            UNAWA
          </Text>. All rights reserved
          { "\n"}
          Ver. 2.1.4
        </Text>
        </>
       :
       <Text style={[styles.copyRightStyle, { left: 0, alignSelf: 'flex-end', textAlign: 'right', paddingRight: 100, }]}>
          <Text style={styles.copyRightBtnStyle} onPress={() => navigation.navigate("terms-condition")}>Terms & Conditions</Text> {"\n"}
          <Text style={styles.copyRightBtnStyle} onPress={() => navigation.navigate("privacy-policy")}>Privacy Policy</Text>
          {"\n"}

          {"\n"}© 2025 SignSecure {"\n"} All rights reserved
          </Text>
       }
    </Animated.View>
  );
};

export default CopyRightContent;
